/**
 * Runtime switch between the two interfaces (#75).
 *
 * The new interface (src/next/) is the default. REACT_APP_UI=classic
 * (window._env_, written by env.sh like every other runtime variable) starts
 * the previous GUI instead - as a fallback for installations that need it.
 */
export function isClassicUi(env) {
    return Boolean(env && typeof env.REACT_APP_UI === "string" && env.REACT_APP_UI.trim().toLowerCase() === "classic");
}

export function isNextUi(env) {
    return !isClassicUi(env);
}
